import * as React from 'react';
import {
    Stack, Paper, IconButton, Box, Tooltip, Chip, Typography, Button, Pagination,
} from '@mui/material'
import RefreshIcon from '@mui/icons-material/Refresh';
import {
    DataGrid,
    GridToolbarContainer,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
} from '@mui/x-data-grid';

import * as CONSTANTS from '../../constants'

function getRowId(row) {
    return row.uid;
}
  

export default function ApproveTable({lang, datas, refreshDatas, maxPage}) {

    const [page, setPage] = React.useState(1);

    const columns = [
        { 
            field: "request_type", 
            headerName: CONSTANTS.APPROVE_TOPIC.COMMON.TABLE_HEADERS.REQUEST_TYPE[lang], 
            width: 110, 
            resizable: true,
            renderCell: (params) => {
                var request_type = params.row.request_type;
                var label = request_type === 'new'? CONSTANTS.APPROVE_TOPIC.COMMON.ITEM.NEW[lang]: CONSTANTS.APPROVE_TOPIC.COMMON.ITEM.UPDATE[lang];
                return (
                    <Chip 
                        label={label}
                        variant="outlined"
                    />
                );
            }
        },
        { 
            field: "name", 
            headerName: CONSTANTS.APPROVE_TOPIC.COMMON.TABLE_HEADERS.NAME[lang], 
            width: 300, 
            resizable: true 
        },
        { 
            field: "existing_uid", 
            headerName: CONSTANTS.APPROVE_TOPIC.COMMON.TABLE_HEADERS.UID[lang], 
            width: 100, 
            resizable: true 
        },
        { 
            field: "status", 
            headerName: CONSTANTS.APPROVE_TOPIC.COMMON.TABLE_HEADERS.STATUS[lang], 
            width: 150, 
            resizable: true,
            renderCell: (params) => {
                var status = params.row.status;
                var color = status === 'Available'? '#50C878': '#FA5053';
                var label = status === 'Available'? CONSTANTS.APPROVE_TOPIC.COMMON.ITEM.AVAILABLE[lang]: CONSTANTS.APPROVE_TOPIC.COMMON.ITEM.REVIEWING[lang];
                return (
                    <Chip 
                        label={label}
                        variant="outlined"
                        sx={{backgroundColor: color}}
                    />
                );
            }
        },
        { 
            field: "uid", 
            headerName: CONSTANTS.APPROVE_TOPIC.COMMON.TABLE_HEADERS.OTHERS[lang], 
            width: 130, 
            resizable: true,
            renderCell: (params) => {
                var temp_id = params.row.uid;
                return (
                    <Button 
                        variant='contained'
                        href={`preview/${temp_id}`}
                        disabled={params.row.status!=='Available'}
                    >
                        {CONSTANTS.APPROVE_TOPIC.COMMON.BUTTONS.PREVIEW[lang]}
                    </Button>
                );
            }
        },
    ];

    const CustomToolbar = () => {
        return (
            <GridToolbarContainer>
                <GridToolbarColumnsButton />
                <GridToolbarFilterButton />
                <Box sx={{ flexGrow: 1 }} />
                <Tooltip title='Reload data' >
                    <IconButton onClick={()=> refreshDatas(page)}> 
                        <RefreshIcon />
                    </IconButton>
                </Tooltip>
            </GridToolbarContainer>
        );
    }

    const handlePageChange = (event, curPage) => {
        setPage(curPage);
        refreshDatas(curPage);
    };

    return (
        <Paper sx={{ overflow: "auto" }}>
            <DataGrid
                rows={datas}
                columns={columns}
                checkboxSelection
                hideFooter={true}
                sx={{ border: 0 }}
                getRowId={getRowId}
                rowHeight={60}
                slots={{
                    toolbar: CustomToolbar,
                }}
            />
            {/** Pagination */}
            <Box 
                display="flex" 
                justifyContent="center"
                p={1}
            >
                <Pagination 
                    count={maxPage} 
                    shape="rounded" 
                    showFirstButton
                    showLastButton
                    page={page}
                    onChange={handlePageChange}
                />
            </Box>
        </Paper>
    );
}
